export default {
  copyrights: {
    en: 'SCENTBIRD © {year}, All rights reserved.',
  },
  madeWith: {
    en: 'Made with <span aria-label="love"></span> in NYC.',
  },
}
